import { Autocomplete, Button, Grid, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from "@mui/material";
import React, { Fragment, useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import axios from "axios";
import _, { debounce } from "lodash";
import { param } from "jquery";
import { useStyle } from "../style";
import { Delete, Search } from "@mui/icons-material";

const BarcodeEntry = () => {
  const classes = useStyle()
  const dispatch = useDispatch();
  const codeRef = useRef(null)
  const [data, setData] = useState([])
  const [code, setCode] = useState("")
  const [supplier, setSupplier] = useState([]);
  const [search , setSearch] = useState('')
  const [catData, setCatData] = useState([]);
  const [subData, setSubData] = useState([]);
  const [headData, setHeadData] = useState([])
  const [typeData, setTypeData] = useState([])
  const [productData, setProductData] = useState([])
  const outletId = localStorage.getItem('outlet_id')
  const [selectedProduct, setSelectedProduct] = useState(null);

  const [options, setOptions] = useState({
    customer : null,
    category : null,
    subCategory : null,
    type: null,
    head: null,
    product: null
})
  function handleOptions(value, name){
    console.log(name, value)
    setOptions(prev=>({...prev,[name] : value}))
    // if(name==='product'){
    //     codeRef.current.focus()
    // }
    if (name === 'product') {
      setSelectedProduct(value); // Save selected product details
      codeRef.current.focus();
    }
}

const outletName = localStorage.getItem('outlet_name');
const selectedOutlet = supplier.find(outlet => outlet.fullname === outletName);

const filteredSupplier = supplier.filter(outlet => outlet.fullname === outletName);

const handleCodeChange = (e) =>{
    // setCode(e.target.value)
    setCode(e.target.value.toUpperCase());

}
const handleCodeKeyPress = (e) => {
  if (e.key === "Enter" && code !== '' && selectedProduct) {
    axios.post(`/v1/barcode/entry/check`, { barcode: code })
      .then(res => {
        const objData = {
          prod_id: selectedProduct.id,
          prod_code: selectedProduct.pro_code,
          barcode: code,
          opng_stock: selectedProduct.op_stk,
          balnc_stock: selectedProduct.balance,
          company_id: 1,
          outlet_id: selectedOutlet?.id,
          purchase_no: '',
          outlet_discount: 0,
          prod_name: selectedProduct.pro_name,
          mrp: selectedProduct.mrp,
        };
        const existingItemIndex = data.findIndex(item => item.barcode === objData.barcode);
        const arr = [...data];
        if (existingItemIndex !== -1) {
          dispatch(setSnackbar(true, 'error', 'Barcode already exists!'));
          setCode("");
          setData(arr);
        } else {
          arr.push(objData);
          setData(arr);
          setCode("");
        }
        codeRef.current.focus();
      })
      .catch(err => {
        dispatch(setSnackbar(true, 'error', 'Barcode already exists'));
      });
  }
};
function handleDelete(val, id){
    console.log(val, id)
    const arr =[...data]
    arr.splice(id, 1)
    console.log(arr)
    setData(arr)
    
}
function handleSubmit(){
    const postData = _.map(data,(val=>({
        prod_id : val.prod_id,
        pro_code : val.pro_code,
        barcode: val.barcode,
        company_id: val.company_id,
        outlet_id: val.outlet_id,
        opng_stock: val.opng_stock,
        balnc_stock: val.balnc_stock,
        purchase_no: val.purchase_no,
        outlet_discount: val.outlet_discount
    })))
    axios.post('/v1/barcode/list', {barcode_details: postData})
    .then(res=>{
        console.log(res)
        setData([])
        setSelectedProduct(null);
        setOptions(prev=>({...prev, category: null, customer: null, head: null, product: null, subCategory: null, type: null}))
    })
    .catch(err=>{
        console.log(err)
        dispatch(setSnackbar(true, 'error', err.response.data.errors[0].message))
    })
}
  function getSupplierData() {
    axios
      .get("/v1/outlet/list/1")
      .then((res) => {
        console.log(res.data);
        setSupplier(res.data)
      })
      .catch((err) => {
        dispatch(setSnackbar(true, "error", err.response.data.error));
      });
  }
  console.log(supplier,"setSupplier")
  function getCategory() {
    axios
      .get("/v1/categories")
      .then((res) => {
        _.filter(res.data, (val) => {
          if (val.is_active) {
            setCatData(res.data);
          }
        });
      })
      .catch((err) => {
        console.log(err);
        dispatch(setSnackbar(true, "error", err.response.data.error));
      });
  }
  function getSubCategory() {
    axios
      .get("/v1/subcategories")
      .then((res) => {
        setSubData(res.data);
      })
      .catch((err) => {
        console.log(err);
        dispatch(setSnackbar(true, "error", err.response.data.error));
      });
  }
  function getHead(){
    axios.get('/v1/Head')
    .then(res=>{
        setHeadData(res.data)
    })
    .catch(err=>{
        dispatch(setSnackbar(true,'error',err.response.error))
    })
}
function getTypeData(){
    axios.get('/v1/typedesign')
    .then(res=>{
        setTypeData(res.data)
    })
    .catch(err=>{
        dispatch(setSnackbar(true,'error',err.response.error))
    })
}
console.log('Table Data:', data);

// function getProductData(){
//     const {category, customer, head, subCategory, type} = options
//     const url = `/v1/outlet_item_filter/${customer.id}`
//     const searchUrl = `/v1/outlet_item_filter/${customer.id}/${search}`
//     // http://0.0.0.0:4444/v1/Item/:outlet_id/:head/:type/:category/:subcategory
//     // axios.get(`/v1/Item/${customer.id}/${head.id}/${type.id}/${category.id}/${subCategory.id}`)
//     axios.get(search === '' ? url : searchUrl)
//     .then(res=>{
//         console.log(res.data)
//         setProductData(res.data)
//     })
//     .catch(err=>{
//         console.log(err)
//         dispatch(setSnackbar(true,'error',err.response.data.errors[0].message))
//     })
    
// }
function getProductData() {
  const url = `/v1/outlet_item_filter/${outletId}`;
  const searchUrl = `/v1/outlet_item_filter/${outletId}/${search}`;

  axios.get(search === '' ? url : searchUrl)
    .then(res => {
      if (res.data.length > 0) {
        setProductData(res.data); // Set product data only if results are available
      } else {
        // setProductData([]); // Clear data if no results are found
      }
    })
    .catch(err => {
      console.log("Error fetching product data:", err);
      dispatch(setSnackbar(true, 'error', err.response.data.errors[0].message));
    });
}


const handleInputChange = debounce((event, value) => {
  if (value.length > 2) {
    setSearch(value);  // Set search term for API call
  } else {
    setSearch('');  // Clear search when input is too short
    setProductData([]); // Clear product data to show no results
  }
},);  // Debounce delay of 300ms

  useEffect(()=>{
    getSupplierData()
    getCategory()
    getSubCategory()
    getHead()
    getTypeData()
  },[])
  // useEffect(()=>{
  //   if(search.length > 2){
  //     getProductData()

  //   }
  //   if(search == ''){
  //     setProductData([])
  //   }
  // },[search])
  useEffect(()=>{
    getProductData()
  },[search])
  useEffect(() => {
    if (search.length > 2) {
      getProductData(search);  // Fetch filtered products based on search input
    }
  }, [search]);
  
  return (
    <Fragment>
      <Helmet>
        <title>Barcode Entry</title>
      </Helmet>
      <Typography variant="h6">Barcode Entry</Typography>
      <Grid container spacing={2} className="p-2 pt-2 ">
        <Grid item md={3}>
        {/* <Typography variant="h6">{outletName}</Typography> */}

             <Autocomplete 
            size="small"
            // value={options.customer}
            // options={supplier}
            value={selectedOutlet || null}  // Set the selected outlet as the default value
            options={filteredSupplier} 
            onChange={(e,value)=>handleOptions(value,'customer')}
            getOptionLabel={option=>option.fullname}
            renderInput={(params)=><TextField{...params} label="Select Outlet" />}
            /> 
        </Grid>
   <Grid item md={3}>
      {/* <Autocomplete 
        size='small'
        options={productData}
        value={options.product}
        getOptionLabel={option => option.pro_name}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        onChange={(e, value) => handleOptions(value, 'product')}
        onInputChange={(e, newInputValue) => {setSearch(newInputValue);console.log(newInputValue)}} 
        renderInput={(params) => (
          <TextField {...params} label='Product List'/>
        )}
      /> */}
      <Autocomplete
  size='small'
  options={productData}
  value={options.product}
  getOptionLabel={option => option.pro_name}
  isOptionEqualToValue={(option, value) => option.id === value.id}
  onChange={(e, value) => handleOptions(value, 'product')}
  // onInputChange={handleInputChange} // Debounced input change
  onInputChange={(e, newInputValue) => handleInputChange(e, newInputValue)}
  renderInput={(params) => (
    <TextField {...params} label='Product List'/>
  )}
/>
    </Grid>
      </Grid>
      <TableContainer className={classes.tblRoot} sx={{ maxHeight:450 }}>
      <Table stickyHeader aria-label="sticky table">
        <TableHead className={classes.tblHeader} sx={{position: "sticky",top: 0,}}>
          <TableRow className={classes.tablrow}>
              <TableCell className={classes.tblCell} sx={{borderLeft:'0.5px solid  #ccc'}}>S.no</TableCell>
              <TableCell className={classes.tblCell} sx={{minWidth:"150px"}}>Barcode</TableCell>
              <TableCell className={classes.tblCell} sx={{minWidth:"150px"}}>Product Name</TableCell>
              <TableCell className={classes.tblCell}>MRP</TableCell>
              <TableCell className={classes.tblCell} sx={{maxWidth:100}}>Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
            {_.map(data, (val,idx)=>(
                <TableRow className={classes.tablrow} key={idx}>
                    <TableCell  padding="checkbox" className={classes.tblContentCell} sx={{borderLeft:'0.5px solid  #ccc'}}>{idx + 1}</TableCell>
                    <TableCell >{val.barcode}</TableCell>
                    <TableCell variant="body">{val.prod_name}</TableCell>
                    <TableCell padding="checkbox">{val.mrp}</TableCell>
                    <TableCell padding="checkbox"><IconButton sx={{padding: 0}} onClick={()=>handleDelete(val, idx)}><Delete color="error"/></IconButton></TableCell>
                </TableRow>
            ))}
          <TableRow className={classes.tablrow} 
          ref={(ref)=>{
            if (codeRef.current) {
               // Scroll the row into view
               ref?.scrollIntoView({ behavior: "smooth", block: "center" });
             }  
           }}>
            <TableCell padding="checkbox" className={classes.tblContentCell} sx={{borderLeft:'0.5px solid  #ccc'}}>{data.length + 1}</TableCell>
            <TableCell padding="checkbox"  className={classes.tblContentCell}>
                <TextField 
                inputRef={codeRef}
                size='small'
                value={code}
                onChange={handleCodeChange}
                onKeyPress={handleCodeKeyPress}
                fullWidth/>
            </TableCell>
            <TableCell  className={classes.tblContentCell} sx={{width:100}}/>
            <TableCell  className={classes.tblContentCell} sx={{width:100}}/>
            <TableCell  className={classes.tblContentCell} sx={{width:100}}><IconButton sx={{padding: 0}}><Delete color="error"/></IconButton></TableCell>
          </TableRow>
        </TableBody>
      </Table>
      </TableContainer>
      <Grid className="flex justify-end pt-3">
        {data.length > 0 && <Button variant="contained" size="small" onClick={handleSubmit}>Save</Button>}
      </Grid>
    </Fragment>
  );
};

export default BarcodeEntry;
